import script from "./enarticlelist.vue?vue&type=script&setup=true&lang=js"
export * from "./enarticlelist.vue?vue&type=script&setup=true&lang=js"

import "./enarticlelist.vue?vue&type=style&index=0&id=58b29c88&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b29c88"]])

export default __exports__